(() => {
  const placeSizeGuide = () => {
    document.querySelectorAll('.product-info').forEach((productInfo) => {
      const benefitList = productInfo.querySelector('.feature-badge-list');
      const sizeGuide = productInfo.querySelector('[data-rc-size-guide]');
      const sizeGuideItem = sizeGuide?.closest('.product-info__block-item');
      const trigger = sizeGuide?.querySelector('.rc-size-guide__trigger');

      if (!benefitList || !sizeGuideItem || !trigger) return;

      const nativeSizeGuideItem = [...productInfo.querySelectorAll('.product-info__block-item[data-block-type="feature-with-icon"]')].find((item) => {
        const label = item.querySelector('.feature-badge p');
        return label?.textContent.trim() === 'Size Guide';
      });

      if (nativeSizeGuideItem) {
        const nativeTrigger = nativeSizeGuideItem.querySelector('.feature-badge');
        if (!nativeTrigger) return;

        const benefitDrawers = sizeGuideItem.querySelector('[data-rc-benefit-drawers]');
        if (benefitDrawers && benefitDrawers.parentElement !== document.body) {
          document.body.append(benefitDrawers);
        }
        sizeGuideItem.hidden = true;
        if (nativeSizeGuideItem.parentElement !== benefitList) {
          benefitList.append(nativeSizeGuideItem);
        }
        nativeSizeGuideItem.classList.add('rc-size-guide-badge-item');
        nativeSizeGuideItem.style.setProperty('margin-block-start', '0', 'important');
        nativeSizeGuideItem.style.setProperty('margin-block-end', '0', 'important');
        nativeSizeGuideItem.style.setProperty('margin-top', '0', 'important');
        nativeSizeGuideItem.style.setProperty('margin-bottom', '0', 'important');
        nativeTrigger.classList.add('rc-benefit-card-click');
        nativeTrigger.setAttribute('role', 'button');
        nativeTrigger.setAttribute('tabindex', '0');

        if (nativeTrigger.dataset.rcSizeGuideProxy !== 'true') {
          nativeTrigger.dataset.rcSizeGuideProxy = 'true';
          const openSizeGuide = (event) => {
            event.preventDefault();
            trigger.click();
          };
          nativeTrigger.addEventListener('click', openSizeGuide);
          nativeTrigger.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') openSizeGuide(event);
          });
        }
        return;
      }

      sizeGuideItem.classList.add('rc-size-guide-badge-item');
      // The theme assigns spacing from the original Liquid block type. Once
      // the block is moved into the four-column benefit row, that inherited
      // spacing would lower Size Guide relative to the other three items.
      sizeGuideItem.style.setProperty('margin-block-start', '0', 'important');
      sizeGuideItem.style.setProperty('margin-block-end', '0', 'important');
      sizeGuideItem.style.setProperty('margin-top', '0', 'important');
      sizeGuideItem.style.setProperty('margin-bottom', '0', 'important');
      trigger.classList.add('feature-badge', 'rc-benefit-card-click');

      // Match the markup used by the three native benefit badges so the
      // Size Guide label inherits the exact same baseline and line height.
      if (!trigger.querySelector('p')) {
        const label = document.createElement('p');
        label.textContent = trigger.textContent.trim();
        trigger.replaceChildren(label);
      }

      if (sizeGuideItem.parentElement !== benefitList) {
        benefitList.append(sizeGuideItem);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeSizeGuide);
  } else {
    placeSizeGuide();
  }

  new MutationObserver(placeSizeGuide).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
